import extractPageText from "./extractPageText"

let cachedIndex = null

// Building the index renders every page once to extract its text, so it's done
// lazily on first use and cached for the rest of the session rather than on load.
// pageIndex.js pulls in every page component (and their heavier dependencies,
// e.g. the syntax highlighter), so it's required here rather than imported at
// module scope to keep that weight out of anything that merely renders the
// search box without using it.
export default function getSearchIndex() {
    if (!cachedIndex) {
        const buildPageIndex = require("./pageIndex").default
        cachedIndex = buildPageIndex().map((page) => ({
            to: page.to,
            title: page.title,
            section: page.section,
            text: extractPageText(page.component)
        }))
    }
    return cachedIndex
}
